import React, { useContext, useEffect, useState } from 'react';
import { FormInput, Row, FormSelect, Table, ColumnProps } from '@digital/ui';
import QuestionarioContextProvider from '../../../../../hooks/useQuestionario';
import './custom.css';
import { AnexoDemanda, obterAnexosReaberturaRequisicao, validaCentroCusto, validaOiSge } from '@app/api/demanda';

import ModalSelectItemServico from '../ModalSelectItemServico';
import { getItemsServicoOptionByCodigo } from '@app/api/itemServico';
import { getAllCentroCustoOptions } from '@app/api/centrocusto';
import { getAllLotacaoDestinoOptions, getLotacaoDestinoByCodigo } from '@app/api/lotacaoDestino';
import { hasPermission } from '@app/helpers/permissions';
import { UploadComponent } from '@app/components';
import { Visibility } from '@app/components/Visibility';

interface IRequisicaoCompraItemOiOmLotacaoProps {
  disabled?: boolean;
  forceDisabled?: boolean;
  isModification?: boolean;
}

const RequisicaoCompraItemOiOmLotacao = ({ disabled, forceDisabled, isModification = false }: IRequisicaoCompraItemOiOmLotacaoProps) => {
  const [timer, setTimer] = useState<number | null>(null);
  const {
    statusCodigo,
    itemServicoOptions,
    demandaData,
    setExibirModalSelectItemServico,
    setItemServicoOptions,
    codCentroDeCusto,
    setCodCentroDeCusto,
    centroDeCusto,
    setCentroDeCusto,
    codLotacaoDestino,
    setCodLotacaoDestino,
    lotacaoDestino,
    setLotacaoDestino,
    codOrdemInvestimento,
    setCodOrdemInvestimento,
    ordemInvestimento,
    setOrdemInvestimento,
    ordemManutencao,
    setOrdemManutencao,
    itemServico,
    setItemServico,
    capex,
    setCapex,
    opex,
    setOpex,
    contaResultado,
    setContaResultado,
    projeto,
    pacote,
    setPacote,
    setProjeto,
  } = useContext(QuestionarioContextProvider);

  const [preenchendoCentroCusto, setPreenchendoCentroCusto] = useState(false);
  const [preenchendoOrdemInvestimento, setPreenchendoOrdemInvestimento] = useState(false);
  const [preenchendoOrdemManutencao, setPreenchendoOrdemManutencao] = useState(false);
  const [lotacaoDestinoDisabled, setLotacaoDestinoDisabled] = useState(false);
  const [anexos, setAnexos] = useState<AnexoDemanda[]>([]);
  const [tipoDespesa, setTipoDespesa] = useState('');

  const validaOI = (oi: string) => {
    validaOiSge(oi).then(data => {
      if (data) {
        if (data.nome) setOrdemInvestimento(data.nome);
        else setOrdemInvestimento('');
        if (data.codigoPacote) setPacote(data.codigoPacote);
        if (data.projeto) setProjeto(data.projeto);
        setCodCentroDeCusto(data.centroCusto);
        validaCC(data.centroCusto);
      } else {
        setOrdemInvestimento('');
        setPacote('');
        setProjeto('');
      }
    });
  };

  const validaCC = (cc: string) => {
    validaCentroCusto(cc).then(data => {
      if (data) {
        if (data.descricao) {
          setCentroDeCusto(data.descricao);
        }
      }
    });
  };

  const onChangeCentroCusto = (change: string) => {
    setCodCentroDeCusto(change);
    if (change && change.length > 0) {
      setPreenchendoCentroCusto(true);
      getLotacaoDestinoByCodigo(change).then(lotacaoDestino => {
        if (lotacaoDestino) {
          setCodLotacaoDestino(lotacaoDestino.codigo);
          setLotacaoDestino(lotacaoDestino.centroCusto);
          setLotacaoDestinoDisabled(true);
        } else {
          setLotacaoDestinoDisabled(false);
          setLotacaoDestino('');
          setCodLotacaoDestino(undefined);
        }
      });
    } else {
      setPreenchendoCentroCusto(false);
      setCentroDeCusto('');
    }

    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }
    setTimer(
      setTimeout(() => {
        setCodCentroDeCusto(change);
        if (change && change.length > 0) validaCC(change);
      }, 1000),
    );
  };

  const onChangeLotacaoDestino = (change: string) => {
    setCodLotacaoDestino(change);
    getLotacaoDestinoByCodigo(change).then(lotacaoDestino => {
      if (lotacaoDestino) {
        if (lotacaoDestino) setLotacaoDestino(lotacaoDestino.centroCusto);
        else setLotacaoDestino('');
      }
    });
  };

  const onChangeOrdemInvestimento = (change: string) => {
    setCodOrdemInvestimento(change);
    if (change.length > 0) setPreenchendoOrdemInvestimento(true);
    else {
      setPreenchendoOrdemInvestimento(false);
      setOrdemInvestimento('');
      setCentroDeCusto('');
      setCodCentroDeCusto('');
    }

    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }
    setTimer(
      setTimeout(() => {
        setCodOrdemInvestimento(change);
        if (change.length > 0) validaOI(change);
      }, 1000),
    );
  };

  const onChangeOrdemManutencao = (change: string) => {
    setOrdemManutencao(change);
    if (change.length > 0) setPreenchendoOrdemManutencao(true);
    else setPreenchendoOrdemManutencao(false);

    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }
    setTimer(
      setTimeout(() => {
        setCodCentroDeCusto(demandaData.codCentroCustoDemandante);
        setCentroDeCusto(demandaData.centroCustoDemandante);
        setOrdemManutencao(change);
      }, 1000),
    );
  };

  const handleSelectDespesa = e => {
    setCodCentroDeCusto('');
    setCentroDeCusto('');
    setLotacaoDestino('');
    setCodLotacaoDestino('');
    setOrdemManutencao('');
    setCodOrdemInvestimento('');
    setOrdemInvestimento('');
    setPacote('');
    setProjeto('');

    if (e === 'capex') {
      setCapex(true);
      setOpex(false);
      setContaResultado(false);
    }
    if (e === 'opex') {
      setOpex(true);
      setCapex(false);
      setContaResultado(false);
    }
    if (e === 'resultado') {
      setContaResultado(true);
      setCapex(false);
      setOpex(false);
    }
  };

  useEffect(() => {
    getItemsServicoOptionByCodigo(itemServico).then(options => {
      setItemServicoOptions(options);
    });
  }, [itemServico]);

  useEffect(() => {
    if (demandaData) {
      if (demandaData.ordemManutencao) setPreenchendoOrdemManutencao(true);
      else if (demandaData.codOrdemInvestimento) {
        setPreenchendoOrdemInvestimento(true);
        validaOI(demandaData.codOrdemInvestimento);
      } else if (demandaData.codCentroDeCusto) setPreenchendoCentroCusto(true);
      else {
        setPreenchendoCentroCusto(false);
        setPreenchendoOrdemInvestimento(false);
        setPreenchendoOrdemManutencao(false);
      }

      if (demandaData.codCentroDeCusto) {
        if (demandaData.codCentroDeCusto === demandaData.codLotacaoDestino) {
          setLotacaoDestinoDisabled(true);
        }
      }
    }
  }, [demandaData]);

  const getAnexosReabertura = () => {
    obterAnexosReaberturaRequisicao(demandaData.id).then(data => {
      if (data && data.length >= 2) {
        setAnexos(data);
      } else {
        if (data === undefined) data = [];

        if (data.findIndex(c => c.descricaoDocumento.includes('Formulário')) < 0) {
          data.push({
            descricaoDocumento: 'Formulário de Requisição de Compras',
            id: 'formulario',
            obrigatorio: false,
            arquivos: undefined,
            automatico: true,
            demandaId: demandaData.id,
          });
        }
        if (data.findIndex(c => c.descricaoDocumento.includes('Aprovação')) < 0) {
          data.push({
            descricaoDocumento: 'Aprovação para Alteração de OI',
            id: 'aprovacao',
            obrigatorio: false,
            arquivos: undefined,
            automatico: true,
            demandaId: demandaData.id,
          });
        }
        setAnexos(data);
      }
    });
  };

  useEffect(() => {
    if (demandaData) {
      getAnexosReabertura();
    }
  }, [demandaData]);
  
  useEffect(() => {
    if (capex) {
      setTipoDespesa('capex');
    } else if (opex) {
      setTipoDespesa('opex');
    } else if (contaResultado) {
      setTipoDespesa('resultado');
    }
  }, [demandaData, capex, opex, contaResultado]);

  const columns: ColumnProps<AnexoDemanda>[] = [
    {
      title: 'Descrição',
      dataIndex: 'descricaoDocumento',
    },
    {
      title: 'Arquivo',
      dataIndex: 'arquivos',
      render: (text, record) => (record.arquivos ? record.arquivos[0].nome : ''),
    },
    {
      title: 'Ações',
      dataIndex: 'acoes',
      render: (text, record, index) => {
        return (
          <UploadComponent
            id={record.id}
            nomeIdFormulario={'Id'}
            idDoComponente={`mrn-upload-${record.descricaoDocumento}`}
            hasFile={record.arquivoAtual !== undefined ? true : false}
            label="Anexar"
            iconName="messaging-attach"
            enderecoApi={`anexoDemanda/UploadAnexoDemandaReabertura/${demandaData.id}`}
            buttonClass="labeled"
            retorno={async data => {
              if (data.valid) {
                getAnexosReabertura();
              }
            }}
          />
        );
      },
    },
  ];

  return (
    <>
      <Row>
        <ModalSelectItemServico disabled={disabled} />
        <Visibility visible={isModification}>
          <FormSelect
            id='mrn-select-tipoDespesa'
            label="Tipo de Despesa"
            span={4}
            value={tipoDespesa}
            name="tipoDespesa"
            disabled={disabled}
            onSelect={e => handleSelectDespesa(e)}
            options={[
              { text: 'CAPEX', value: 'capex' },
              { text: 'OPEX', value: 'opex' },
              { text: 'Conta de Resultado', value: 'resultado' },
            ]}
          />
        </Visibility>
      </Row>

      <Visibility
        visible={opex === true}
      >
        <Row className={'label-overflow'}>
          <FormSelect
            label="Centro de Custo"
            name="codCentroDeCusto"
            id='mrn-select-centroDeCusto'
            span={3}
            value={codCentroDeCusto}
            getOptions={getAllCentroCustoOptions}
            showSearch
            allowClear
            onChange={e => {
              onChangeCentroCusto(e);
            }}
            disabled={forceDisabled || disabled}
            required={
              (ordemManutencao === undefined || ordemManutencao.length === 0) &&
              (codCentroDeCusto === undefined || codCentroDeCusto.length === 0)
            }
          />
          <FormInput
            label=" "
            name="centroDeCusto"
            id='mrn-input-centroDeCusto'
            span={5}
            disabled
            value={centroDeCusto}
            required={
              (centroDeCusto === undefined || centroDeCusto.length === 0) &&
              (ordemManutencao === undefined || ordemManutencao.length === 0)
            }
          />
        </Row>
        <Row className={'label-overflow'}>
          <FormSelect
            label="Lotacao Destino"
            name="codLotacaoDestino"
            id='mrn-select-lotacaoDestino'
            span={3}
            value={codLotacaoDestino}
            getOptions={getAllLotacaoDestinoOptions}
            showSearch
            onSelect={e => {
              onChangeLotacaoDestino(e);
            }}
            disabled={
              forceDisabled ||
              disabled ||
              preenchendoOrdemInvestimento ||
              preenchendoOrdemManutencao ||
              statusCodigo !== 3 ||
              !hasPermission(['PRE_SUPRIMENTOS_DEMANDA_CADASTRAR_REQUISICAO']) ||
              lotacaoDestinoDisabled
            }
            required={preenchendoCentroCusto && (codLotacaoDestino === undefined || codLotacaoDestino.length === 0)}
          />
          <FormInput
            label=" "
            name="lotacaoDestino"
            id='mrn-input-lotacaoDestino'
            span={5}
            disabled
            value={lotacaoDestino}
            required={preenchendoCentroCusto && (lotacaoDestino === undefined || lotacaoDestino.length === 0)}
          />
        </Row>
        <Row>
          <FormInput
          type='number'
            label="Ordem de Manutenção"
            name="ordemManutencao"
            id='mrn-input-ordemManutencao'
            span={8}
            value={Number(ordemManutencao) || ''}
            onChange={e => {
              onChangeOrdemManutencao(e.currentTarget.value);
            }}
            disabled={forceDisabled || disabled}
          />
        </Row>
      </Visibility>

      <Visibility
        visible={capex === true}
      >
        <Row>
          <FormInput
            label="Ordem Investimento"
            name="codOrdemInvestimento"
            id="mrn-input-codOrdemInvestimento"
            value={codOrdemInvestimento}
            span={3}
            onChange={e => {
              onChangeOrdemInvestimento(e.currentTarget.value);
            }}
            disabled={forceDisabled || disabled}
          />
          <FormInput
            label=" "
            name="ordemInvestimento"
            id="mrn-input-ordemInvestimento"
            span={5}
            value={ordemInvestimento}
            required={
              preenchendoOrdemInvestimento && (ordemInvestimento === undefined || ordemInvestimento.length === 0)
            }
            disabled
          />
        </Row>
        <Row>
          <FormInput name="pacote" id='mrn-input-pacote' label="Pacote" value={pacote} span={3} disabled />
          <FormInput name="projeto" id='mrn-input-projeto' label="Projeto" value={projeto} span={5} disabled />
        </Row>

        {demandaData.reaberturaRequisicaoCompra === true &&
          (codOrdemInvestimento !== demandaData.codOrdemInvestimento ||
            anexos.findIndex(c => c.id !== 'formulario' && c.id !== 'aprovacao') <= 0) && (
            <Row style={{ paddingTop: '16px', marginInline: '10px', paddingInline: '4px' }}>
              <Table
                id="mrn-table-formulario"
                dataSource={anexos} columns={columns} rowKey="id" pagination={false} />
            </Row>
          )}
      </Visibility>

      <Visibility
        visible={contaResultado === true}
      >
        <Row className={'label-overflow'}>
          <FormSelect
            label="Centro de Custo"
            name="codCentroDeCusto"
            id='mrn-select-centroDeCusto'
            span={3}
            value={codCentroDeCusto}
            getOptions={getAllCentroCustoOptions}
            showSearch
            allowClear
            onChange={e => {
              onChangeCentroCusto(e);
            }}
            disabled={forceDisabled || disabled}
            required={
              (ordemManutencao === undefined || ordemManutencao.length === 0) &&
              (codCentroDeCusto === undefined || codCentroDeCusto.length === 0)
            }
          />
          <FormInput
            label=" "
            name="centroDeCusto"
            id='mrn-input-centroDeCusto'
            span={5}
            disabled
            value={centroDeCusto}
            required={
              (centroDeCusto === undefined || centroDeCusto.length === 0) &&
              (ordemManutencao === undefined || ordemManutencao.length === 0)
            }
          />
        </Row>
        <Row className={'label-overflow'}>
          <FormSelect
            label="Lotacao Destino"
            name="codLotacaoDestino"
            id='mrn-select-lotacaoDestino'
            span={3}
            value={codLotacaoDestino}
            getOptions={getAllLotacaoDestinoOptions}
            showSearch
            onSelect={e => {
              onChangeLotacaoDestino(e);
            }}
            disabled={
              forceDisabled ||
              disabled ||
              preenchendoOrdemInvestimento ||
              preenchendoOrdemManutencao ||
              statusCodigo !== 3 ||
              !hasPermission(['PRE_SUPRIMENTOS_DEMANDA_CADASTRAR_REQUISICAO']) ||
              lotacaoDestinoDisabled
            }
            required={preenchendoCentroCusto && (codLotacaoDestino === undefined || codLotacaoDestino.length === 0)}
          />
          <FormInput
            label=" "
            name="lotacaoDestino"
            id='mrn-input-lotacaoDestino'
            span={5}
            disabled
            value={lotacaoDestino}
            required={preenchendoCentroCusto && (lotacaoDestino === undefined || lotacaoDestino.length === 0)}
          />
        </Row>
      </Visibility>
    </>
  );
};
export default RequisicaoCompraItemOiOmLotacao;
